import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { HeaderService } from "../header/header.service";

export class Version {
  public appName: string;
  public version: string;
  public machineName: string;
  public serverIp: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private httpClient: HttpClient;
  protected exclude: boolean = true;

  constructor(handler: HttpBackend, private headerService: HeaderService) {
    this.httpClient = new HttpClient(handler);
  }

  public async initialize(): Promise<void> {
    let timeStamp = Date.now();
    let serverVersion = await this.getVersion(timeStamp);

    const currentVersion = localStorage.getItem('appVersion');

    this.checkVersionAndReload(currentVersion, serverVersion);

    const checkTime = this.headerService.getUrl('versionCheckTime');

    setInterval(() => { this.controlVersion() }, checkTime);
  }

  private async getVersion(timeStamp: number): Promise<Version> {
    let version = await this.httpClient.get<Version>(`appVersion.json?${timeStamp}`).toPromise();
    version.machineName = location.hostname;
    version.serverIp = location.host;

    return version;
  }

  /**
  * Obtiene la version local y la version del servidor
  */
  private async controlVersion(): Promise<void> {
    let timeStamp = Date.now();
    let serverVersion = await this.getVersion(timeStamp);
    const currentVersion = localStorage.getItem('appVersion');

    this.checkVersionAndReload(currentVersion, serverVersion);
  }

  /**
  * Compara las versiónes y recarga si es necesario
  */
  private checkVersionAndReload(currentVersion: string, serverVersion: Version): void {

    console.log(`server version: ${serverVersion.version} browser version: ${currentVersion}`);

    if (serverVersion.version != currentVersion) {
      localStorage.setItem('appVersion', serverVersion.version);
      location.reload();
    }
  }
}
